<div class="mm-skill-profile-popup-diagram" role="img">
    <canvas #radarCanvas ></canvas>
</div>
